import React, { memo } from 'react'

import SubSection from './SubSection'

let tabIndex = 0
const SubSections = memo(({ subSections = [], onSectionClick }) =>
  subSections.map((subSection, index) => {
    const returnSubsection = subSection.featureEnabled &&
      subSection.hasElmoTreatment && (
        <SubSection
          tabIndex={tabIndex}
          key={`subSection-${index}`}
          {...subSection}
          iconMiddle
          onSectionClick={onSectionClick}
        />
      )
    tabIndex++
    return returnSubsection
  }),
)
SubSections.displayName = 'SubSections'
export default SubSections
